module.exports = __webpack_public_path__ + "assets/images/heart_disease_r.3c6bac9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/heart_disease_r.png
// module id = 730
// module chunks = 1